// src/services/review.service.js
import axios from "axios";
import { auth } from "../config/firebase";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5172/api";

const getAuthHeader = async () => {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

export const reviewService = {
  // Get reviews (public, no auth needed)
  getReviews: async (productId) => {
    const res = await axios.get(`${API_URL}/reviews/${productId}`);
    return res.data;
  },

  // Add review (protected)
  addReview: async (productId, formData) => {
    const headers = await getAuthHeader();

    const res = await axios.post(`${API_URL}/reviews/${productId}`, formData, {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  },
};
